import { render } from "./preview_item.vue?vue&type=template&id=2c4cff36&scoped=true&lang=pug"
import script from "./preview_item.vue?vue&type=script&lang=js"
export * from "./preview_item.vue?vue&type=script&lang=js"

import "./preview_item.vue?vue&type=style&index=0&id=2c4cff36&scoped=true&lang=css"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4cff36"]])

export default __exports__